import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    benefitsModule: {
        flex: 1,
        padding: 10,
        flexDirection: 'row',
    },
    benefitsModuleList: {
        flex: 1,
        paddingHorizontal: 10,
        paddingVertical: 10,
        flexDirection: 'row',
    },
    benefitsContainer: {
        flex: 1,
        flexDirection: 'column',
        borderWidth: 0.5,
        marginHorizontal: 3,
        borderColor: theme.colors.lightGray,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
    },
    benefitImage: {
        flex: 1,
        marginTop: 0,
        borderRadius: 10,
        maxWidth: '100%',
        aspectRatio: 1,
    },
    containerTextIcon: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
    },
    seeMoreText: {
        fontSize: 11,
        color: theme.colors.colorPrimary,
        fontWeight: 'normal',
    },
    benefitHistoryImage: {
        width: 65,
        marginVertical: 10,
        marginRight: 10,
        aspectRatio: 1,
        alignItems: 'center',
        borderRadius: 8,
    },
    benefitHistoryDescriptions: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    textBlock: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        backgroundColor: theme.colors.modalBackground,
        borderRadius: 8,
        padding: 10,
    },
    titleSection: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 15,
        paddingHorizontal: 15,
    },
    textSubBlockList: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    title: {
        flex: 1,
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 5,
        marginBottom: 5,
        justifyContent: 'center',
        color: theme.colors.textPrimary,
        textAlign: 'left',
    },
    benefits: {
        fontSize: 15,
        marginBottom: 5,
        fontWeight: 'medium',
        color: theme.colors.textPrimary,
    },
    benefitCategoryName: {
        fontSize: 15,
        textTransform: 'uppercase',
        marginBottom: 2,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    pointsBlock: {
        flexDirection: 'row',
        width: width / 2 - 45,
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    justifyCenter: {
        justifyContent: 'center',
    },
    points: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
    },
    status: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        paddingHorizontal: 10,
        paddingVertical: 3,
        borderRadius: 5,
        overflow: 'hidden',
        alignItems: 'center',
    },
    date: {
        fontSize: 11,
        color: theme.colors.textSecondary,
        marginBottom: 5,
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
        marginVertical: 10,
    },
    stock: {
        fontSize: 16,
    },
    description: {
        fontSize: 12,
        marginBottom: 10,
    },
    details: {
        fontSize: 14,
        marginBottom: 10,
    },
    stockBlock: {
        flexDirection: 'row',
    },
    detailsBlocks: {
        flexDirection: 'row',
    },
    imageIcon: {
        width: 15,
        height: 15,
    },
})

export default styles
